// extracted by mini-css-extract-plugin
export default {"personalInfo":"personalinfo_personalInfo__dELEN","title":"personalinfo_title__p8vFs","contact":"personalinfo_contact__A-Xb8"};